import { StyledIcon, StyledTypography } from "@insite/mobius/Link";
import LinkPresentationPropsDefault from "@insite/mobius/Link/presentationProps";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import { xBaseTheme } from "@stoneage/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...LinkPresentationPropsDefault,
        hoverMode: undefined,
        typographyProps: {
            weight: 600,
            size: "inherit",
            lineHeight: "inherit",
            color: "primary",
            css: css`
                &:hover,
                &:focus,
                &:hover span,
                &:focus span {
                    text-decoration: none;
                }
            `,
        },
        hoverStyle: {},
        css: css``,
    },
} as xBaseTheme["link"];
